// ====== NAVBAR SCROLL ======
const navbar = document.getElementById('siteNav');
if (navbar) {
  window.addEventListener('scroll', () => {
    navbar.classList.toggle('scrolled', window.scrollY > 60);
  });
}

// ====== SCROLL REVEAL ======
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
}, { threshold: 0.12 });
document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

// ====== COUNTER ANIMATION ======
const counterObs = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      const el = e.target;
      const target = parseFloat(el.getAttribute('data-target'));
      const isDecimal = String(target).includes('.');
      let start = 0;
      const duration = 1800;
      const step = 16;
      const increment = target / (duration / step);
      const timer = setInterval(() => {
        start += increment;
        if (start >= target) { start = target; clearInterval(timer); }
        el.textContent = isDecimal ? start.toFixed(1) : Math.floor(start);
      }, step);
      counterObs.unobserve(el);
    }
  });
}, { threshold: 0.5 });
document.querySelectorAll('.counter').forEach(el => counterObs.observe(el));

// ====== TOAST ======
function showToast(msg) {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = '✓  ' + msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 2200);
}

// ====== CART DRAWER (real Shopify AJAX Cart API) ======
function openCart() {
  document.getElementById('cartOverlay').classList.add('open');
  document.getElementById('cartDrawer').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  document.getElementById('cartOverlay').classList.remove('open');
  document.getElementById('cartDrawer').classList.remove('open');
  document.body.style.overflow = '';
}
document.getElementById('cartBtn')?.addEventListener('click', () => { openCart(); refreshCartDrawer(); });
document.getElementById('cartOverlay')?.addEventListener('click', closeCart);
document.getElementById('closeCartBtn')?.addEventListener('click', closeCart);

async function refreshCartDrawer() {
  const res = await fetch('/cart.js');
  const cart = await res.json();
  renderCartDrawer(cart);
}

function renderCartDrawer(cart) {
  const badge = document.getElementById('cartBadge');
  const itemsEl = document.getElementById('cartItems');
  const footerEl = document.getElementById('cartFooter');
  const totalEl = document.getElementById('cartTotal');

  if (badge) {
    badge.textContent = cart.item_count;
    badge.classList.toggle('show', cart.item_count > 0);
  }

  if (!itemsEl) return;

  if (cart.item_count === 0) {
    itemsEl.innerHTML = `<div class="cart-empty">
      <svg width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>
      <span>Your cart is empty</span>
    </div>`;
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  if (footerEl) footerEl.style.display = 'block';
  if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

  itemsEl.innerHTML = cart.items.map(item => `
    <div class="cart-item" data-key="${item.key}">
      <div class="cart-item-img"><img src="${item.image}" alt="${item.product_title}"></div>
      <div class="cart-item-details">
        <div class="cart-item-name">${item.product_title}</div>
        <div class="cart-item-price">${formatMoney(item.final_price)}</div>
        <div class="cart-item-qty">
          <button class="qty-btn" data-key="${item.key}" data-delta="-1">−</button>
          <span class="qty-val">${item.quantity}</span>
          <button class="qty-btn" data-key="${item.key}" data-delta="1">+</button>
          <span class="remove-item" data-key="${item.key}">Remove</span>
        </div>
      </div>
    </div>`).join('');

  itemsEl.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => changeLineQty(btn.dataset.key, parseInt(btn.dataset.delta)));
  });
  itemsEl.querySelectorAll('.remove-item').forEach(el => {
    el.addEventListener('click', () => removeLine(el.dataset.key));
  });
}

function formatMoney(cents) {
  return '₹' + (cents / 100).toLocaleString('en-IN');
}

async function addToCartById(variantId, btn) {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (!res.ok) throw new Error('add failed');
    const item = await res.json();
    if (btn) {
      const original = btn.textContent;
      btn.textContent = '✓ Added';
      btn.classList.add('added');
      setTimeout(() => { btn.textContent = original; btn.classList.remove('added'); }, 1500);
    }
    showToast(item.product_title + ' added to cart');
    refreshCartDrawer();
  } catch (err) {
    showToast('Could not add item — check stock');
  }
}

async function changeLineQty(key, delta) {
  const res = await fetch('/cart.js');
  const cart = await res.json();
  const line = cart.items.find(i => i.key === key);
  if (!line) return;
  const newQty = line.quantity + delta;
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: newQty })
  });
  refreshCartDrawer();
}

async function removeLine(key) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  });
  refreshCartDrawer();
}

// Hook up all "Add to Cart" buttons on the page
document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    addToCartById(btn.dataset.variantId, btn);
  });
});

// Load cart count on page load
refreshCartDrawer();

// ====== B2B QUOTE FORM (submits via Shopify contact form) ======
window.handleQuoteToast = function () {
  showToast('Quote request sent! We\'ll contact you within 4 hours.');
};
